module.exports = __webpack_public_path__ + "static/media/life-co-funded-by-the-eu-vertical.5af3e564.png";